// Shop catalog and target definitions for Crossbow Chaos

export const ASSETS = {
  // targets
  target_number67: "/assets/target_number67.png",
  target_chicken_head: "/assets/target_chicken_head.png",
  target_angry_donut: "/assets/target_angry_donut.png",
  target_dancing_potato: "/assets/target_dancing_potato.png",
  target_toilet_paper: "/assets/target_toilet_paper.png",
  target_banana_shades: "/assets/target_banana_shades.png",
  target_giant_eyeball: "/assets/target_giant_eyeball.png",
  target_hotdog_rocket: "/assets/target_hotdog_rocket.png",
  target_skull: "/assets/target_skull.png",
  target_trophy: "/assets/target_trophy.png",
  target_arrow_pack: "/assets/target_arrow_pack.png",
  target_coin: "/assets/target_coin.png",
  target_pinata: "/assets/target_pinata.png",
  target_magnet: "/assets/target_magnet.png",
  target_lightning: "/assets/target_lightning.png",
  target_wheel: "/assets/target_wheel.png",
  target_pizza_slice: "/assets/target_pizza_slice.png",
  target_ice_cream: "/assets/target_ice_cream.png",
  target_rubber_duck: "/assets/target_rubber_duck.png",
  target_pickle_ninja: "/assets/target_pickle_ninja.png",
  target_ufo_cow: "/assets/target_ufo_cow.png",
  target_trex_skate: "/assets/target_trex_skate.png",

  // crossbows
  crossbow_wooden: "/assets/crossbow_wooden.png",
  crossbow_golden: "/assets/crossbow_golden.png",
  crossbow_fire: "/assets/crossbow_fire.png",
  crossbow_ice: "/assets/crossbow_ice.png",
  crossbow_hercules: "/assets/crossbow_hercules.png",
  crossbow_laser: "/assets/crossbow_laser.png",
  crossbow_rainbow: "/assets/crossbow_rainbow.png",
  crossbow_phoenix: "/assets/crossbow_phoenix.png",
  crossbow_diamond: "/assets/crossbow_diamond.png",
  crossbow_champion: "/assets/crossbow_champion.png",
  crossbow_candy: "/assets/crossbow_candy.png",
  crossbow_cupid: "/assets/crossbow_cupid.png",
  crossbow_shadow: "/assets/crossbow_shadow.png",
  crossbow_stellar: "/assets/crossbow_stellar.png",
  crossbow_cosmic: "/assets/crossbow_cosmic.png",
  crossbow_galaxy: "/assets/crossbow_galaxy.png",
  crossbow_boss_slayer: "/assets/crossbow_boss_slayer.png",
  crossbow_chain: "/assets/crossbow_chain.png",
  crossbow_skeleton: "/assets/crossbow_skeleton.png",
  crossbow_prism: "/assets/crossbow_prism.png",

  // skins
  skin_ninja: "/assets/skin_ninja.png",
  skin_chicken: "/assets/skin_chicken.png",
  skin_number67: "/assets/skin_number67.png",
  skin_hercules: "/assets/skin_hercules.png",
  skin_robot: "/assets/skin_robot.png",
  skin_banana_king: "/assets/skin_banana_king.png",
  skin_unicorn: "/assets/skin_unicorn.png",
  skin_wizard: "/assets/skin_wizard.png",
  skin_astronaut: "/assets/skin_astronaut.png",
  skin_dragon: "/assets/skin_dragon.png",
  skin_default: "/assets/skin_default.png",
  skin_champion: "/assets/skin_champion.png",
  skin_cowboy: "/assets/skin_cowboy.png",
  skin_pirate: "/assets/skin_pirate.png",
  skin_alien: "/assets/skin_alien.png",
  skin_superhero: "/assets/skin_superhero.png",
  skin_vampire: "/assets/skin_vampire.png",
  skin_zombie: "/assets/skin_zombie.png",
  skin_mermaid: "/assets/skin_mermaid.png",
  skin_boss_slayer: "/assets/skin_boss_slayer.png",
  skin_chain: "/assets/skin_chain.png",
  skin_skeleton: "/assets/skin_skeleton.png",
  skin_party_hero: "/assets/skin_party_hero.png",
};

// Unique target IDs used by "Hit 'Em All" mode (excludes skull).
export const UNIQUE_TARGET_IDS = [
  "target_angry_donut",
  "target_chicken_head",
  "target_number67",
  "target_dancing_potato",
  "target_banana_shades",
  "target_toilet_paper",
  "target_giant_eyeball",
  "target_hotdog_rocket",
];

// Target definitions
// difficulty: easy=10, medium=50, hard=120, skull=-30
// minLevel: minimum progression level at which target starts appearing
// motion: 'linear' | 'bounce' | 'spin' | 'zigzag' | 'rocket'
export const TARGETS = [
  { id: "target_angry_donut",   name: "Angry Donut",      difficulty: "easy",   coin: 10,  size: 90,  motion: "linear",  minLevel: 1, description: "A furious pink frosted donut with sprinkle rage. Easy to hit." },
  { id: "target_chicken_head",  name: "Chicken Head",     difficulty: "easy",   coin: 10,  size: 90,  motion: "bounce",  minLevel: 1, description: "A bouncy, clucky chicken head in tiny shades. Boing boing." },
  { id: "target_number67",      name: "Number 67",        difficulty: "medium", coin: 50,  size: 100, motion: "spin",    minLevel: 1, description: "A spinning goofy giant 67. Track the rotation." },
  { id: "target_dancing_potato",name: "Dancing Potato",   difficulty: "medium", coin: 50,  size: 95,  motion: "zigzag",  minLevel: 2, description: "A disco spud that zig-zags to its own beat." },
  { id: "target_banana_shades", name: "Banana Shades",    difficulty: "medium", coin: 50,  size: 90,  motion: "bounce",  minLevel: 2, description: "A bouncy banana with neon sunglasses and zero chill." },
  { id: "target_toilet_paper",  name: "Flying TP",        difficulty: "hard",   coin: 120, size: 80,  motion: "zigzag",  minLevel: 3, description: "A winged TP roll that zigzags erratically. Worth a pile of coins." },
  { id: "target_giant_eyeball", name: "Giant Eyeball",    difficulty: "hard",   coin: 120, size: 110, motion: "spin",    minLevel: 3, description: "A massive spinning eyeball. Dizzying but lucrative." },
  { id: "target_hotdog_rocket", name: "Hotdog Rocket",    difficulty: "hard",   coin: 120, size: 110, motion: "rocket",  minLevel: 4, description: "A hotdog blasting across the arena on a rocket. Lead your shot!" },
  // New kid-friendly targets (ages 8-12)
  { id: "target_pizza_slice",   name: "Runaway Pizza",    difficulty: "easy",   coin: 10,  size: 95,  motion: "bounce",  minLevel: 1, description: "A pizza slice with legs, running for its life." },
  { id: "target_ice_cream",     name: "Ice Cream Sneak",  difficulty: "easy",   coin: 10,  size: 90,  motion: "linear",  minLevel: 1, description: "A mischievous ice cream cone sliding by. Don't let it melt away." },
  { id: "target_rubber_duck",   name: "Ducky McShades",   difficulty: "medium", coin: 50,  size: 90,  motion: "bounce",  minLevel: 2, description: "A cool rubber duck with shades. Boings unpredictably." },
  { id: "target_pickle_ninja",  name: "Pickle Ninja",     difficulty: "medium", coin: 50,  size: 85,  motion: "zigzag",  minLevel: 2, description: "A stealthy ninja pickle darting sideways. Tricky." },
  { id: "target_ufo_cow",       name: "UFO & Cow",        difficulty: "hard",   coin: 120, size: 115, motion: "spin",    minLevel: 3, description: "An alien saucer beaming up a spinning cow. Out of this world." },
  { id: "target_trex_skate",    name: "T-Rex Skater",     difficulty: "hard",   coin: 120, size: 115, motion: "rocket",  minLevel: 4, description: "A skateboarding T-Rex flying past. Blink and it's gone." },
];

// Skull target is special — hitting it penalizes the player.
export const SKULL_TARGET = {
  id: "target_skull",
  name: "Cursed Skull",
  difficulty: "skull",
  coin: -30,
  size: 90,
  motion: "linear",
  minLevel: 1,
};

// Arrow Pack — a bonus pickup that refills +20 arrows when shot.
export const ARROW_PACK_TARGET = {
  id: "target_arrow_pack",
  name: "Arrow Pack",
  difficulty: "pack",
  coin: 0,
  size: 85,
  motion: "bounce",
  emoji: "🏹", // fallback glyph if PNG ever fails to load
};

// Trophy target — only used in Trophy Trial mode.
export const TROPHY_TARGET = {
  id: "target_trophy",
  name: "Golden Trophy",
  difficulty: "trophy",
  coin: 0,
  size: 95,
  motion: "bounce",
  emoji: "🏆",
};

// Piñata Party — destructible container that bursts into candy targets.
export const PINATA_TARGET = {
  id: "target_pinata",
  name: "Piñata",
  difficulty: "pinata",
  coin: 0,
  size: 140,
  motion: "bounce",
  // Gift-box fallback (Unicode 6.0) — renders on every platform if the PNG
  // ever fails. The originally-shipped 🪅 was U+1FA85 / Unicode 13.0 and
  // didn't render in older mobile WebViews.
  emoji: "🎁",
};

// Magnet Pull — purple magnet that pulls nearby targets into a cluster, then
// chain-pops them on hit. Has its own 3-second lifespan.
export const MAGNET_TARGET = {
  id: "target_magnet",
  name: "Magnet",
  difficulty: "magnet",
  coin: 0,
  size: 110,
  motion: "bounce",
  emoji: "🧲",
  lifespan: 180,
};

// Slow-Mo Drop — lightning pickup that triggers 3 seconds of bullet time.
export const LIGHTNING_TARGET = {
  id: "target_lightning",
  name: "Lightning",
  difficulty: "lightning",
  coin: 0,
  size: 80,
  motion: "linear",
  emoji: "⚡",
};

// Lucky Wheel — random reward pickup (arrows / timer / coins / slow-mo).
export const WHEEL_TARGET = {
  id: "target_wheel",
  name: "Lucky Wheel",
  difficulty: "wheel",
  coin: 0,
  size: 110,
  motion: "bounce",
  emoji: "🎰",
  lifespan: 240,
};

// Coin Storm — falling pure-positive pickup, +50 coins, never penalizes.
export const COIN_PICKUP_TARGET = {
  id: "target_coin",
  name: "Coin",
  difficulty: "coin_pickup",
  coin: 50,
  size: 70,
  motion: "linear",
  // Money-bag fallback (Unicode 6.0) — renders on every platform if the PNG
  // ever fails. The originally-shipped 🪙 was U+1FA99 / Unicode 13.0 and
  // didn't render in older mobile WebViews.
  emoji: "💰",
};

// Shop catalog.
// Items may have `emoji` — rendered as a placeholder when no PNG asset exists.
export const CROSSBOWS = [
  { id: "crossbow_wooden",      name: "Wooden Crossbow",   price: 0,    starter: true },
  { id: "crossbow_golden",      name: "Golden Crossbow",   price: 800 },
  { id: "crossbow_fire",        name: "Fire Crossbow",     price: 1500 },
  { id: "crossbow_ice",         name: "Ice Crossbow",      price: 2500 },
  { id: "crossbow_laser",       name: "Laser Crossbow",    price: 3500 },
  { id: "crossbow_rainbow",     name: "Rainbow Crossbow",  price: 4000 },
  { id: "crossbow_diamond",     name: "Diamond Crossbow",  price: 4500 },
  { id: "crossbow_phoenix",     name: "Phoenix Crossbow",  price: 5500 },
  { id: "crossbow_hercules",    name: "Hercules Crossbow", price: 7000 },
  // Emoji-only placeholders (PNGs can be added later)
  { id: "crossbow_candy",       name: "Candy Crossbow",    price: 1200, emoji: "🍭" },
  { id: "crossbow_cupid",       name: "Cupid Crossbow",    price: 2200, emoji: "💘" },
  { id: "crossbow_shadow",      name: "Shadow Crossbow",   price: 3200, emoji: "🌑" },
  { id: "crossbow_stellar",     name: "Stellar Crossbow",  price: 5000, emoji: "🌟" },
  { id: "crossbow_cosmic",      name: "Cosmic Crossbow",   price: 8000, emoji: "🌌" },
  { id: "crossbow_galaxy",      name: "Galaxy Crossbow",   price: 9500, emoji: "🌑" },
  // Unlock rewards
  { id: "crossbow_champion",    name: "Champion Crossbow", price: 0, unlockCondition: "trophy_trial" },
  { id: "crossbow_boss_slayer", name: "Boss Slayer",       price: 0, unlockCondition: "boss", emoji: "👹" },
  { id: "crossbow_chain",       name: "Chain Crossbow",    price: 0, unlockCondition: "chain_master", emoji: "🔗" },
  { id: "crossbow_skeleton",    name: "Skeleton Crossbow", price: 0, unlockCondition: "skull_dodge", emoji: "💀" },
  { id: "crossbow_prism",       name: "Prism Crossbow",    price: 0, unlockCondition: "color_match", emoji: "🌈" },
];

export const ARROWS = [
  { id: "arrow_normal",    name: "Normal Arrows",    price: 0,    starter: true,  color: "#E0E0E0", glow: "#FFFFFF" },
  { id: "arrow_golden",    name: "Golden Arrows",    price: 500,  color: "#FFD700", glow: "#FFF0A0" },
  { id: "arrow_candy",     name: "Candy Arrows",     price: 800,  color: "#FF69B4", glow: "#FFC0E0" },
  { id: "arrow_fireball",  name: "Fireball Arrows",  price: 900,  color: "#FF6A00", glow: "#FF2D00" },
  { id: "arrow_rainbow",   name: "Rainbow Arrows",   price: 1200, color: "rainbow", glow: "#FF00FF" },
  { id: "arrow_poison",    name: "Poison Arrows",    price: 1600, color: "#9DFF2E", glow: "#39FF14" },
  { id: "arrow_star",      name: "Star Arrows",      price: 1900, color: "#FFEE88", glow: "#FFD700" },
  { id: "arrow_diamond",   name: "Diamond Arrows",   price: 2400, color: "#B5EBFF", glow: "#FFFFFF" },
  { id: "arrow_magic",     name: "Magic Arrows",     price: 2600, color: "#B366FF", glow: "#A020F0" },
  { id: "arrow_lightning", name: "Lightning Arrows", price: 3000, color: "#00FFFF", glow: "#80FFFF" },
  { id: "arrow_shadow",    name: "Shadow Arrows",    price: 3400, color: "#444466", glow: "#6633AA" },
  { id: "arrow_chain",     name: "Chain Arrows",     price: 0,    color: "#C8CFDC", glow: "#B366FF", unlockCondition: "chain_master" },
  { id: "arrow_skeleton",  name: "Bone Arrows",      price: 0,    color: "#ECE7D2", glow: "#A4FF9E", unlockCondition: "skull_dodge" },
  { id: "arrow_streak",    name: "Streak Arrows",    price: 0,    color: "#FF007F", glow: "#00FFFF", unlockCondition: "combo_frenzy" },
];

export const SKINS = [
  { id: "skin_default",     name: "Default Archer",  price: 0,    starter: true },
  { id: "skin_ninja",       name: "Ninja Outfit",    price: 600 },
  { id: "skin_chicken",     name: "Chicken Costume", price: 900 },
  { id: "skin_number67",    name: "Number 67 Skin",  price: 1200 },
  { id: "skin_wizard",      name: "Wizard Skin",     price: 1800 },
  { id: "skin_unicorn",     name: "Unicorn Skin",    price: 2200 },
  { id: "skin_hercules",    name: "Hercules Skin",   price: 2500 },
  { id: "skin_astronaut",   name: "Astronaut Skin",  price: 2800 },
  { id: "skin_robot",       name: "Robot Skin",      price: 3200 },
  { id: "skin_dragon",      name: "Dragon Skin",     price: 3600 },
  { id: "skin_banana_king", name: "Banana King",     price: 4000 },
  // Emoji-only placeholders
  { id: "skin_cowboy",      name: "Cowboy Outfit",   price: 1600, emoji: "🤠" },
  { id: "skin_pirate",      name: "Pirate Outfit",   price: 2000, emoji: "🏴" },
  { id: "skin_alien",       name: "Alien Outfit",    price: 2400, emoji: "👽" },
  { id: "skin_superhero",   name: "Super Hero",      price: 3000, emoji: "🦸" },
  { id: "skin_vampire",     name: "Vampire Skin",    price: 3400, emoji: "🧛" },
  { id: "skin_zombie",      name: "Zombie Skin",     price: 3800, emoji: "🧟" },
  { id: "skin_mermaid",     name: "Mermaid Skin",    price: 4200, emoji: "🧜" },
  // Unlock rewards
  { id: "skin_champion",    name: "Champion Skin",   price: 0, unlockCondition: "trophy_trial" },
  { id: "skin_boss_slayer", name: "Boss Slayer Skin", price: 0, unlockCondition: "boss", emoji: "👺" },
  { id: "skin_chain",       name: "Chain Master Skin", price: 0, unlockCondition: "chain_master", emoji: "⛓️" },
  { id: "skin_skeleton",    name: "Skeleton Skin",     price: 0, unlockCondition: "skull_dodge", emoji: "💀" },
  { id: "skin_party_hero",  name: "Birthday Hero",     price: 0, unlockCondition: "pinata_party", emoji: "🥳" },
];

// Mini games definitions
export const MINI_GAMES = [
  {
    id: "tiny_fast",
    name: "Tiny & Fast",
    tagline: "Pip-squeak targets, lightning speed",
    icon: "⚡",
    color: "#FF007F",
    duration: 30,
    hitGoal: 12,
  },
  {
    id: "zigzag",
    name: "Zigzag Madness",
    tagline: "Wiggly wobbly moving targets",
    icon: "〰️",
    color: "#00FFFF",
    duration: 30,
    hitGoal: 10,
  },
  {
    id: "rain",
    name: "Bonus Rain",
    tagline: "A falling parade of silly prizes",
    icon: "💰",
    color: "#FFD700",
    duration: 25,
    hitGoal: 18,
  },
  {
    id: "boss",
    name: "Boss Challenge",
    tagline: "TWO bosses. They shrink. They regen. You must destroy both.",
    icon: "👹",
    color: "#39FF14",
    duration: 55,
    hitGoal: 2,
  },
  {
    id: "hit_em_all",
    name: "Hit 'Em All",
    tagline: "One of each. No repeats. Don't mess up!",
    icon: "🎯",
    color: "#A020F0",
    duration: 50,
    hitGoal: 8, // == UNIQUE_TARGET_IDS.length
  },
  {
    id: "trophy_trial",
    name: "Trophy Trial",
    tagline: "3 arrows. Hit the trophy. Skulls void your prize!",
    icon: "🏆",
    color: "#FFD700",
    duration: 30,
    hitGoal: 1,
  },
  // --- 10 new mini-games ---
  {
    id: "balloon_pop",
    name: "Balloon Pop",
    tagline: "Pop the floaty balloons before they escape!",
    icon: "🎈",
    color: "#FF69B4",
    duration: 30,
    hitGoal: 15,
  },
  {
    id: "speed_demon",
    name: "Speed Demon",
    tagline: "20 seconds. Pure chaos. GO!",
    icon: "🏎️",
    color: "#FF3B30",
    duration: 20,
    hitGoal: 22,
  },
  {
    id: "giants",
    name: "Giant Hunt",
    tagline: "Big slow beasties. Worth extra coins!",
    icon: "🦖",
    color: "#39FF14",
    duration: 30,
    hitGoal: 8,
  },
  {
    id: "swarm",
    name: "Swarm Attack",
    tagline: "Tons of tiny targets at once",
    icon: "🐝",
    color: "#FFD700",
    duration: 30,
    hitGoal: 25,
  },
  {
    id: "skull_dodge",
    name: "Skull Dodge",
    tagline: "Skulls everywhere. One hit ends it!",
    icon: "☠️",
    color: "#FF3B30",
    duration: 120,
    hitGoal: 12,
  },
  {
    id: "frozen",
    name: "Frozen Time",
    tagline: "Everything moves in slow motion",
    icon: "❄️",
    color: "#00FFFF",
    duration: 30,
    hitGoal: 12,
  },
  {
    id: "rocket_rush",
    name: "Rocket Rush",
    tagline: "Hotdog rockets, flying fast",
    icon: "🚀",
    color: "#FF6A00",
    duration: 30,
    hitGoal: 10,
  },
  {
    id: "bounce_house",
    name: "Bounce House",
    tagline: "Everything bounces. Everywhere.",
    icon: "🏀",
    color: "#A020F0",
    duration: 30,
    hitGoal: 15,
  },
  {
    id: "wall_breaker",
    name: "Wall Breaker",
    tagline: "Smash the walls. Targets are hiding!",
    icon: "🧱",
    color: "#FF6A00",
    duration: 40,
    hitGoal: 10,
  },
  {
    id: "target_chain",
    name: "Target Chain",
    tagline: "One target. Each shot morphs it. Catch every link!",
    icon: "🔗",
    color: "#00FFFF",
    duration: 60,
    // hitGoal set dynamically to the chain length below
    hitGoal: 14,
  },
  {
    id: "chain_master",
    name: "Chain Master",
    tagline: "3 hits per link. 2 minutes. Win the Chain Crossbow!",
    icon: "⛓️",
    color: "#B366FF",
    duration: 120,
    hitGoal: 14 * 3, // 14 links × 3 hits
  },
  // --- Kid-friendly chaos batch ---
  {
    id: "pinata_party",
    name: "Piñata Party",
    tagline: "Whack the piñata, catch the candy!",
    icon: "🎉",
    color: "#FF69B4",
    duration: 35,
    hitGoal: 25,
  },
  {
    id: "combo_frenzy",
    name: "Combo Frenzy",
    tagline: "Streak it. Don't break it.",
    icon: "🔥",
    color: "#FF6A00",
    duration: 30,
    hitGoal: 30,
  },
  {
    id: "color_match",
    name: "Color Match",
    tagline: "Only the green ones. Trust me.",
    icon: "🌈",
    color: "#39FF14",
    duration: 30,
    hitGoal: 15,
  },
  {
    id: "shrinking_stars",
    name: "Shrinking Stars",
    tagline: "Big = safe coins. Tiny = jackpot.",
    icon: "⭐",
    color: "#FFD700",
    duration: 30,
    hitGoal: 12,
  },
  {
    id: "firework_frenzy",
    name: "Firework Frenzy",
    tagline: "One shot, ten pops.",
    icon: "🎆",
    color: "#FF007F",
    duration: 30,
    hitGoal: 25,
  },
  {
    id: "bullseye",
    name: "Bullseye Bonanza",
    tagline: "Aim for the gold dot.",
    icon: "🎯",
    color: "#FFD700",
    duration: 30,
    hitGoal: 12,
  },
  {
    id: "conveyor_combo",
    name: "Conveyor Combo",
    tagline: "Hit them left-to-right. In order.",
    icon: "🚂",
    color: "#00FFFF",
    duration: 35,
    hitGoal: 18,
  },
  {
    id: "mole_mash",
    name: "Mole Mash",
    tagline: "They pop up. They duck back.",
    icon: "🐹",
    color: "#A020F0",
    duration: 30,
    hitGoal: 18,
  },
  {
    id: "triple_shot",
    name: "Triple Shot",
    tagline: "Every arrow's a trio.",
    icon: "🏹",
    color: "#39FF14",
    duration: 25,
    hitGoal: 25,
  },
  {
    id: "coin_storm",
    name: "Coin Storm",
    tagline: "Catch the cash, no skulls.",
    icon: "💰",
    color: "#FFD700",
    duration: 30,
    hitGoal: 20,
  },
  // --- Round 2 of kid-friendly chaos ---
  {
    id: "magnet_pull",
    name: "Magnet Pull",
    tagline: "Suck 'em in, then pop the cluster!",
    icon: "🧲",
    color: "#A020F0",
    duration: 30,
    hitGoal: 22,
  },
  {
    id: "hot_potato",
    name: "Hot Potato",
    tagline: "Tick tick BOOM. Shoot fast!",
    icon: "🔥",
    color: "#FF6A00",
    duration: 30,
    hitGoal: 20,
  },
  {
    id: "bouncy_arrows",
    name: "Bouncy Arrows",
    tagline: "Ricochet shots! Trick the walls.",
    icon: "🎱",
    color: "#00FFFF",
    duration: 30,
    hitGoal: 18,
  },
  {
    id: "boomerang",
    name: "Boomerang",
    tagline: "Hit 'em on the way back for triple!",
    icon: "🪃",
    color: "#39FF14",
    duration: 30,
    hitGoal: 16,
  },
  {
    id: "floor_lava",
    name: "Floor Is Lava",
    tagline: "Don't let them touch the ground!",
    icon: "🌋",
    color: "#FF3B30",
    duration: 30,
    hitGoal: 22,
  },
  // --- Round 3 of kid-friendly chaos ---
  {
    id: "splitter",
    name: "Splitter",
    tagline: "Hit one. Split. Hit those. Jackpot!",
    icon: "✂️",
    color: "#FF007F",
    duration: 30,
    hitGoal: 30,
  },
  {
    id: "mirror_twins",
    name: "Mirror Twins",
    tagline: "Hit both before time runs out — bonus!",
    icon: "👯",
    color: "#00FFFF",
    duration: 30,
    hitGoal: 18,
  },
  {
    id: "time_bandit",
    name: "Time Bandit",
    tagline: "15s clock. Every hit adds 1s. Survive!",
    icon: "⏳",
    color: "#FFD700",
    duration: 15,
    hitGoal: 25,
  },
  {
    id: "slowmo",
    name: "Slow-Mo Drop",
    tagline: "Hit the lightning to slow time!",
    icon: "⚡",
    color: "#00FFFF",
    duration: 30,
    hitGoal: 20,
  },
  {
    id: "lucky_wheel",
    name: "Lucky Wheel",
    tagline: "Hit the wheel for a surprise reward!",
    icon: "🎰",
    color: "#FF6A00",
    duration: 30,
    hitGoal: 22,
  },
];

// Chain Master requires this many arrows per link before it morphs.
export const CHAIN_MASTER_HITS_PER_LINK = 3;

// Target Chain mode cycles through every non-special target. Each hit bumps
// the chain index and swaps the target's look; the player wins after the
// last link.
export const CHAIN_SEQUENCE = TARGETS.map((t) => t.id);

export const MINIGAME_REWARD = 500;

// Arrow economy — shared between gameplay (PlayScreen) and UI (HomeScreen).
export const MAX_ARROWS_DEFAULT = 20;
